import React,{useState,useEffect} from 'react'
import './landingpage.scss'
import { BsMic} from "react-icons/bs";
import ReactPlayer from 'react-player';
import { useReactMediaRecorder } from "react-media-recorder";
import axios from 'axios';
import Wave from 'react-wavify'

const LandingPage = () => {
const {status,startRecording,stopRecording,mediaBlobUrl}= useReactMediaRecorder({ audio:true ,echoCancellation: true});
useEffect(()=>{
    if(status==='stopped'){
 
        try{
            async function createFile(fileUrl){
                let response = await fetch(fileUrl);
                let data = await response.blob();
                let metadata = {
                  type: 'voice.wav'
                };
                let file = new File([data], "voice.wav", metadata);
                console.log("file is",file)
                return file
              }
              //to download the file
            // const link = document.createElement("a");
            // link.href = mediaBlobUrl;
            // link.download='Test_1.wav';
            // link.click();
               createFile(mediaBlobUrl)
               .then(resp=>{
                // HTTP CALL AS A FORM DATA: PS SEND A FILE
                // send the current text in api text: 
                console.log(resp)
                var data = new FormData()
                data.append('audio', resp)
                fetch('https://backend.aiopenvalley.com/audio', {
                    credentials:'include',
                    method: 'POST',
                    body: data
                  })
               })
        }catch(err) {
            console.error(err);
        }
    }
},[status])

const [wave,setWave]=useState(false)
const[isActive,setIsActive]=useState();
const[text,setText]=useState(()=>{axios.get('https://backend.aiopenvalley.com/gettext',{withCredentials:true}).then((res)=>{
    console.log(res.data)
    setText(res.data)
 })})
let[count,setCount]=useState(1);
const handleClick=async ()=>{
    setCount(count+1);
    setWave(!wave);
    if (count===1){
    setIsActive(current=>!current)
    startRecording();
    }
    else{
        
        setIsActive(false);
         setCount(1);
     stopRecording();
     axios.get('https://backend.aiopenvalley.com/gettext',{withCredentials:true}).then((res)=>{
            console.log(res.data)
            setText(res.data)

         })   
    }  
};

  return (
        <div className="top">
            <div className="leftTop">
            </div>
            <div className="middle">
                <h2>Data Gathering</h2>
                <div className="middle_div">
                    <h2 className='please'>Please</h2>
                    <p>Read and record the text below.</p>
                    <div className="card">
                        <p className='textLabel'>{text} </p>
                        <button
                        style={{
                            border: isActive? 'solid 1px  #0A9CBC':'red',
                            backgroundColor:isActive? 'red':'',
                            padding:isActive? '30px':'red',
                        }}
                        onClick={handleClick}
                        className='button'>
                            <BsMic className='mic'/>
                        </button>

                        <div className='waveDiv'>
                    {
                    wave? 
                    <Wave
                    fill='#b6effb'
                    paused={false}
                    options={{
                        height: 50,
                        amplitude:25,
                        speed:1,
                        points:100
                    }}
                    />
                    :
                    <Wave
                    fill='#ffff'
                    paused={false}
                    options={{
                        height: 50,
                        amplitude:25,
                        speed:0,
                        points: 7
                    }}
                    />
                    }
                </div>
                    </div>
                </div>
                <div className='aboutUs'>
                    <h3 style={{
                        textAlign:'center',
                        fontStyle: 'normal',
                        fontWeight:500,
                        fontSize: 25,
                        lineHeight:3
                        }}>About Us</h3>
                    <ReactPlayer
                    width='90%'
                    height={500}
                    className='video'
                    url='https://youtu.be/XXxOfUTD7Bw'/>
                    <p className='aboutText'>
                    <p style={{fontSize:20,fontWeight:500}}>FAQs</p>
                        <span style={{fontWeight:600}}>What is data gathering application?</span>
                        <br />
                        The Data gathering app is a mobile responsive web application from which we are trying to collect nepali voices.
                        <br />
                        <span style={{fontWeight:600}}>What can we do with this collected Nepali Voice?</span>
                        <br />
                        This Dataset of nepali voice helps us in many future AI projects.
                        Many big companies do not provide their datasets to the public so through our application, we are trying to build an open source voice dataset for Nepali languages.
                        Now you can donate your Voice to help us create an open source voice database and be a part of upcoming AI projects.
                        <br />
                        <span style={{fontWeight:600}}>How to use this application?</span>
                        <br/>
                        To use this application you just need to speak the Nepali Sentences shown on your screen by clicking on the mic button and when the backgroundcolor of the mic turns green.Also unclicking the mic button stops the recording. In this way, you can contribute your voice.
                    </p>
                </div>
            </div>
            <div className="rightTop">
            </div>
        </div>
  )
}

export default LandingPage;